export enum CarfaxConnectUseCase {
  Current = 'CURRENT',
  ReplacementPrimary = 'REPLACEMENT_PRIMARY',
  ReplacementSecondary = 'REPLACEMENT_SECONDARY',
  TemporaryReplacement = 'TEMPORARY_REPLACEMENT',
  TurnReplacement = 'TURN_REPLACEMENT',
}
